import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_4";
import BlockPrincipal from "../components/block/Block_6";
import BlockSecondary from "../components/block/Block_3";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.stock?.[16]}`}
        />
        <BlockPrincipal
          title={'a little about us'}
          text={rpdata?.dbAbout?.[0]?.text}
          image2={rpdata?.stock?.[12]}
          image1={rpdata?.stock?.[15]}
          image3={rpdata?.stock?.[17]}
          image4={rpdata?.stock?.[13]}
          corte={rpdata?.stock}
          listsAbout
        />
        <ValuesOne
          image={rpdata?.stock?.[15]}
          image1={rpdata?.stock?.[14]}
          image2={rpdata?.stock?.[18]} />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[7]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image={rpdata?.stock?.[12]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
